.composer {
  --input-bd: transparent;
  position: relative;
  flex: 0 1 auto;
  align-self: center;
  padding: var(--mantine-spacing-sm);
  transition: all 0.3s ease-out;

  ::placeholder {
    color: var(--mantine-color-dark-4);
  }
}

.input-container {
  --mantine-radius-default: 10rem;
  position: relative;
  display: grid;
  grid-template-columns: 1fr min-content;
  border-radius: inherit;
  transition: all 0.2s ease-out;
}

.input-textarea {
  width: 100%;
  height: 100%;
  resize: none;
  background: transparent;
  border: transparent;
  border-radius: inherit;

  &:focus {
    outline: none;
  }
}
